import { cva } from "class-variance-authority";
import { buttonSizeScale } from "./button.config.js";

export const buttonVariants = cva(
  "rounded-full inline-flex items-center cursor-pointer justify-center font-medium transition-colors outline-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-2 focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        primary:
          "bg-blue-600 text-white hover:bg-blue-700 focus-visible:ring-blue-500 active:bg-blue-800",
        secondary:
          "bg-gxe-bg-lightblue text-gxe-primary hover:bg-gxe-bg-lightblue/70 hover:text-gxe-primary/80 focus-visible:ring-gray-500 active:bg-gxe-bg-lightblue/60",
        destructive:
          "bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500 active:bg-red-800",
        outline:
          "border-1 border-gxe-border text-gxe-primary hover:bg-gray-50 focus-visible:ring-gray-500 active:bg-gray-100",
        ghost: "text-gray-900 hover:bg-gray-100 focus-visible:ring-gray-500 active:bg-gray-200",
      },
      size: {
        sm: buttonSizeScale.sm.button,
        md: buttonSizeScale.md.button,
        lg: buttonSizeScale.lg.button,
        xl: buttonSizeScale.xl.button,
        icon_xs: buttonSizeScale.xs.icon,
        icon_sm: buttonSizeScale.sm.icon,
        icon_md: buttonSizeScale.md.icon,
        icon_lg: buttonSizeScale.lg.icon,
        icon_xl: buttonSizeScale.xl.icon,
        pill: "h-12 px-6 rounded-full text-base",
      },
      align: {
        none: "items-normal",
        start: "items-start",
        center: "items-center",
        end: "items-end",
      },
      flex: {
        none: "block",
        left: "flex flex-row",
        inline: "inline-flex flex-row",
        right: "flex flex-row-reverse",
        up: "flex flex-col",
        down: "flex flex-col-reverse",
      },
      justify: {
        none: "justify-normal",
        start: "justify-start",
        center: "justify-center",
        between: "justify-between",
        around: "justify-around",
        evently: "justify-evenly",
        end: "justify-end",
      },
      fullWidth: {
        true: "w-full",
      },
    },
    defaultVariants: {
      flex: "left",
      align: "center",
      variant: "primary",
      size: "md",
    },
  }
);
